import React, { useEffect, useState } from 'react';
import { Field, useField } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { formatMoney } from '../../../util/currency';
import { types as sdkTypes } from '../../../util/sdkLoader';
import { FiInfo } from 'react-icons/fi';
import css from './BookingAddons.module.css';

const { Money } = sdkTypes;

const BookingAddons = props => {
  useEffect(() => {
    console.log('BookingAddons mounted');

    return () => {
      console.log('BookingAddons unmounted');
    };
  }, []);
  const { addons = [], className } = props;
  const [openTooltip, setOpenTooltip] = useState(null);
  const intl = useIntl();

  const enabledAddons = addons
    .filter(a => a.enabled)
    .map(addon => ({
      ...addon,
      money:
        addon.price?.amount != null ? new Money(addon.price.amount, addon.price.currency) : null,
    }));

  if (enabledAddons.length === 0) {
    return null;
  }

  return (
    <div className={classNames(css.root, className)}>
      <h3 className={css.heading}>
        <FormattedMessage id="BookingAddons.title" defaultMessage="Optional Add-ons" />
      </h3>

      <p className={css.subHeading}>
        <FormattedMessage
          id="BookingAddons.subtitle"
          defaultMessage="Choose any optional services you'd like to include."
        />
      </p>

      <div className={css.cards}>
        {enabledAddons.map(addon => (
          <Field
            key={addon.id}
            name={`selectedAddons.${addon.id}`}
            type="checkbox"
            component="input"
            onChange={e => {
              input.onChange(e);

              handleFetchLineItems({
                values: {
                  ...formApi.getState().values,
                  selectedAddons: formApi.getState().values.selectedAddons,
                },
              });
            }}
          >
            {({ input }) => (
              <label
                className={classNames(css.card, {
                  [css.selected]: input.checked,
                })}
              >
                <input {...input} className={css.hiddenCheckbox} />

                <div className={css.cardTop}>
                  <div className={css.titleRow}>
                    <div className={css.title}>{addon.title}</div>

                    {addon.description && (
                      <div
                        className={css.infoWrapper}
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          setOpenTooltip(openTooltip === addon.id ? null : addon.id);
                        }}
                      >
                        <FiInfo className={css.infoIcon} />

                        <div
                          className={classNames(css.tooltip, {
                            [css.tooltipOpen]: openTooltip === addon.id,
                          })}
                        >
                          {addon.description}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className={css.checkboxWrapper}>
                    <input
                      {...input}
                      type="checkbox"
                      className={css.checkbox}
                      onClick={e => e.stopPropagation()}
                    />
                  </div>
                </div>

                <div className={css.footer}>
                  <span className={css.price}>
                    {addon.money ? formatMoney(intl, addon.money) : '-'}
                  </span>

                  <span className={css.unit}>
                    {addon.unitType === 'fixed' ? 'Fixed' : `Per ${addon.unitType}`}
                  </span>
                </div>
              </label>
            )}
          </Field>
        ))}
      </div>
    </div>
  );
};

export default BookingAddons;
